import Repository from "./masterRepository";

const getAddOns = "/masters/addOns/get";
const myAddOns = "miniStore/orders/getAddOnsUsage";
const requestAddOns = "miniStore/orders/requestAddOns";
const myAddOnsRequest = "miniStore/orders/getAddOns";

export default {
  getAddOns(payload) {
    return Repository.post(`${getAddOns}`, payload);
  },

  myAddOns(payload) {
    return Repository.post(`${myAddOns}`, payload);
  },

  myAddOnsRequest(payload) {
    return Repository.post(`${myAddOnsRequest}`, payload);
  },

  rquestAddOns(payload) {
    return Repository.post(`${requestAddOns}`, payload);
  },
};
